module.exports = __webpack_public_path__ + "img/eurasia-foundation-logo-transparent.516eb634.png";